export var AdAllocationEntityType;
(function (AdAllocationEntityType) {
    AdAllocationEntityType["team"] = "team";
    AdAllocationEntityType["competition"] = "competition";
})(AdAllocationEntityType || (AdAllocationEntityType = {}));
/** Age options for competitions and teams */
export var Age;
(function (Age) {
    Age["U7"] = "U7";
    Age["U8"] = "U8";
    Age["U9"] = "U9";
    Age["U10"] = "U10";
    Age["U11"] = "U11";
    Age["U12"] = "U12";
    Age["U13"] = "U13";
    Age["U14"] = "U14";
    Age["U15"] = "U15";
    Age["U16"] = "U16";
    Age["U17"] = "U17";
    Age["U18"] = "U18";
    Age["U19"] = "U19";
    Age["U20"] = "U20";
    Age["U21"] = "U21";
    Age["U22"] = "U22";
    Age["U23"] = "U23";
    Age["Adults"] = "Adults";
    Age["Senior"] = "Senior";
})(Age || (Age = {}));
export var EFinishedStatus;
(function (EFinishedStatus) {
    EFinishedStatus["finished"] = "finished";
    EFinishedStatus["pregame"] = "pregame";
    EFinishedStatus["runningLate"] = "runningLate";
    EFinishedStatus["inProgress"] = "inProgress";
    EFinishedStatus["cancelled"] = "cancelled";
    EFinishedStatus["expired"] = "expired";
})(EFinishedStatus || (EFinishedStatus = {}));
export var FactName;
(function (FactName) {
    FactName["CORNER"] = "CORNER";
    FactName["GOAL"] = "GOAL";
    FactName["FOUL"] = "FOUL";
    FactName["YELLOW_CARD"] = "YELLOW_CARD";
    FactName["RED_CARD"] = "RED_CARD";
    FactName["FREE_KICK"] = "FREE_KICK";
    FactName["OFFSIDE"] = "OFFSIDE";
    FactName["SHOT_ON_TARGET"] = "SHOT_ON_TARGET";
    FactName["SHOT_OFF_TARGET"] = "SHOT_OFF_TARGET";
    FactName["PENALTY_SHOOTOUT_MISS"] = "PENALTY_SHOOTOUT_MISS";
    FactName["PENALTY_AWARDED"] = "PENALTY_AWARDED";
    FactName["PENALTY_SHOOTOUT_GOAL"] = "PENALTY_SHOOTOUT_GOAL";
    FactName["POSSESSION_CHANGED"] = "POSSESSION_CHANGED";
    FactName["TRY"] = "TRY";
    FactName["DROP_GOAL"] = "DROP_GOAL";
    FactName["GOAL_KICK_SCORED"] = "GOAL_KICK_SCORED";
    FactName["GOAL_KICK_MISSED"] = "GOAL_KICK_MISSED";
    FactName["PENALTY_GOAL"] = "PENALTY_GOAL";
    FactName["PENALTY_TRY"] = "PENALTY_TRY";
    FactName["TRY_ASSIST"] = "TRY_ASSIST";
    FactName["CONVERSION"] = "CONVERSION";
    FactName["CONVERSION_MISSED"] = "CONVERSION_MISSED";
    FactName["PENALTY_GOAL_MISSED"] = "PENALTY_GOAL_MISSED";
    FactName["DROP_GOAL_MISSED"] = "DROP_GOAL_MISSED";
    FactName["KICKING_COMP_GOALS"] = "KICKING_COMP_GOALS";
    FactName["KICKING_COMP_GOALS_MISSED"] = "KICKING_COMP_GOALS_MISSED";
    FactName["LINEOUT"] = "LINEOUT";
    FactName["LINEOUT_CONCEDED"] = "LINEOUT_CONCEDED";
    FactName["SCRUM"] = "SCRUM";
    FactName["SCRUM_CONCEDED"] = "SCRUM_CONCEDED";
    FactName["CLEAN_BREAK"] = "CLEAN_BREAK";
    FactName["DEFENDER_BEATEN"] = "DEFENDER_BEATEN";
    FactName["PENALTY_CONCEDED"] = "PENALTY_CONCEDED";
    FactName["TURNOVER_CONCEDED"] = "TURNOVER_CONCEDED";
    FactName["RUCK"] = "RUCK";
    FactName["RUCK_CONCEDED"] = "RUCK_CONCEDED";
    FactName["RESTART"] = "RESTART";
    FactName["KICK"] = "KICK";
    FactName["SUBSTITUTION"] = "SUBSTITUTION";
    FactName["PLAYERS_ENTERING"] = "PLAYERS_ENTERING";
    FactName["ABOUT_TO_START"] = "ABOUT_TO_START";
    FactName["PERIOD_STARTED"] = "PERIOD_STARTED";
    FactName["PERIOD_FINISHED"] = "PERIOD_FINISHED";
    FactName["CLOCK_STARTED"] = "CLOCK_STARTED";
    FactName["CLOCK_STOPPED"] = "CLOCK_STOPPED";
    FactName["CLOCK_ADJUSTED"] = "CLOCK_ADJUSTED";
    FactName["PROVIDER_CONNECTED"] = "PROVIDER_CONNECTED";
    FactName["PROVIDER_DISCONNECTED"] = "PROVIDER_DISCONNECTED";
    FactName["PROVIDER_CONNECTION_PROBLEMS"] = "PROVIDER_CONNECTION_PROBLEMS";
    FactName["PROVIDER_MESSAGE"] = "PROVIDER_MESSAGE";
    FactName["LINEUPS"] = "LINEUPS";
    FactName["PLAYERS_SHAKING_HANDS"] = "PLAYERS_SHAKING_HANDS";
    FactName["VIDEO_REF_DELIBERATION"] = "VIDEO_REF_DELIBERATION";
    FactName["MATCH_CANCELLED"] = "MATCH_CANCELLED";
    FactName["ANTHEMS"] = "ANTHEMS";
})(FactName || (FactName = {}));
export var FileEntityType;
(function (FileEntityType) {
    FileEntityType["team"] = "team";
    FileEntityType["club"] = "club";
    FileEntityType["competitionLogo"] = "competitionLogo";
    FileEntityType["competitionWatermarkPrimary"] = "competitionWatermarkPrimary";
    FileEntityType["competitionWatermarkSecondary"] = "competitionWatermarkSecondary";
    FileEntityType["adFile"] = "adFile";
    FileEntityType["player"] = "player";
    FileEntityType["teamPlayer"] = "teamPlayer";
    FileEntityType["user"] = "user";
    FileEntityType["venue"] = "venue";
    FileEntityType["organization"] = "organization";
})(FileEntityType || (FileEntityType = {}));
/** Gender options for competitions and teams */
export var Gender;
(function (Gender) {
    Gender["Male"] = "Male";
    Gender["Female"] = "Female";
    Gender["Mixed"] = "Mixed";
})(Gender || (Gender = {}));
export var PeriodStatus;
(function (PeriodStatus) {
    PeriodStatus["live"] = "live";
    PeriodStatus["break"] = "break";
})(PeriodStatus || (PeriodStatus = {}));
export var PeriodType;
(function (PeriodType) {
    PeriodType["regular"] = "regular";
    PeriodType["overtime"] = "overtime";
})(PeriodType || (PeriodType = {}));
//# sourceMappingURL=api-types.js.map